import React, { useEffect, useState, useRef, Component } from 'react';
import { MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
// Map routes to their accent colors
function getAccentColor(pathname: string): string {
  if (pathname.includes('subcontractors') || pathname.includes('contractors')) {
    return '#F87431';
  }
  // Default brand accent for all other pages
  return '#2e8a44';
}
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastScrollY = useRef(0);
  const location = useLocation();
  const accentColor = getAccentColor(location.pathname);
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const isScrollingDown = currentY > lastScrollY.current && currentY > 100;
      lastScrollY.current = currentY;
      if (isScrollingDown) {
        setVisible(true);
      }
      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      // Hide after 1 second of no scrolling
      scrollTimeoutRef.current = setTimeout(() => {
        setVisible(false);
      }, 1000);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);
  return <AnimatePresence data-id="element-1074">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden flex justify-center" data-id="element-1075">
          <a href={`sms:2066193742?body=${encodeURIComponent("Hi, I'm on your website and I have a question")}`} className="w-[80%] flex items-center justify-center py-4 text-white font-bold text-base rounded-t-3xl" style={{
        backgroundColor: accentColor
      }} data-id="element-1076">
            <MessageSquare className="w-5 h-5 mr-2" data-id="element-1077" />
            Chat Now
          </a>
        </motion.div>}
    </AnimatePresence>;
}